exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:-apple-system,SF UI Text,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif}h1{margin:0}dd,dl,dt,li,ul{list-style:none;margin:0;padding:0}input{border:none;outline:none;padding:0;margin:0}#app{font-family:-apple-system,SF UI Text,Arial,PingFang SC,Hiragino Sans GB,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50}.page{position:absolute;top:0;bottom:0;left:0;right:0;padding:0 4vw;background-color:#f3f3f3}", ""]);

// exports
